import React, { useEffect, useState } from 'react';
import { Divider, Form, Tabs, message, Row, Card } from 'antd';

import {formatObjectAsDotpath} from "../../../utils/tools";
import {
    portfolioNameInput,
    portfolioDescription,
    benchmarkInput,
    targetAllocationSlider,
    objectiveSelect,
    assetClassSelect,
    assetTypeSelect,
    regionSelect,
    strategyTypeSelect
} from "./components/FormFields";
import PortfolioSelector from "../../Portfolio/PortfolioSelectors/PortfolioSelector";
import TickerSearch from "../../../components/TickerSearch/TickerSearch";

const PresentForm = ({
                         selectedTickers, handleTickerUpdate, selectedPortfolios,
                         handlePortfolioUpdate
})=>{
    return (
        <Tabs centered={true}>
            <Tabs.TabPane key={'1'} tab={'Comparison Tickers'}>

                <TickerSearch
                      initialSymbols={selectedTickers} // Pass initial tickers
                      onTickersSubmit={handleTickerUpdate} // Update ticker_ids in the form
                      maxTickers={10} // Example: limit to 10 tickers
                    />
            </Tabs.TabPane>
            <Tabs.TabPane key={'2'} tab={'Comparison Portfolios'}>
                <PortfolioSelector
                    initialSelectedPortfolios={selectedPortfolios} // Pass initial portfolio IDs
                    onSelect={handlePortfolioUpdate} // Update portfolio_ids in the form
                />
            </Tabs.TabPane>
        </Tabs>
    )
}


const PortfolioForm = ({ portfolioId, initialValues, handleSubmit }) => {
  const [form] = Form.useForm();
  const [equityAllocation, setEquityAllocation] = useState(initialValues?.targets?.equity); // Default to 50% for equity
  const [selectedTickers, setSelectedTickers] = useState(initialValues?.view_config?.comparison?.ticker_ids || []); // Initialize with existing tickers
  const [selectedPortfolios, setSelectedPortfolios] = useState(initialValues?.view_config?.comparison?.portfolio_ids || []); // Initialize with existing portfolios
  useEffect(() => {
    if (initialValues) {
      form.setFieldsValue(initialValues);
      setEquityAllocation(initialValues?.targets?.equity);
    }
  }, [initialValues, form]);

  const onSliderChange = (value) => {
    setEquityAllocation(value);
  };

  const handleTickerUpdate = (tickers) => {
      const formattedList = tickers.length > 0 ? tickers.map(ticker => ticker.symbol) : [];
    setSelectedTickers(formattedList); // Update selected tickers
    form.setFieldsValue({
      'view_config.comparison.ticker_ids': formattedList,
    });
  };
  const handlePortfolioUpdate = (portfolios) => {
    const portfolioIds = portfolios.length > 0 ? portfolios.map((portfolio) => portfolio.id) : [];
    setSelectedPortfolios(portfolioIds); // Update selected portfolios
    form.setFieldsValue({
      'view_config.comparison.portfolio_ids': portfolioIds,
    });
  };


  const onSubmit = (values) => {
    const updatedValues = {
      ...values,
      'targets.equity': equityAllocation,
      'targets.fixed': 100 - equityAllocation,
        'view_config.comparison.ticker_ids': selectedTickers, // Ensure tickers are included
      'view_config.comparison.portfolio_ids': selectedPortfolios, // Ensure portfolios are included

    };
    const data = formatObjectAsDotpath(updatedValues, '', {}, true);
    const payload = {portfolioId, data};
    handleSubmit(payload);
    message.success(`Portfolio ${data.name} updated successfully!`);

  };

  // Modular function to render Form.Item with spacing and optional divider
  const renderFormItem = (item, key, showDivider = false) => (
    <React.Fragment key={key}>
      <div style={{ marginBottom: '24px', padding: '20px 30px' }}>
        {item}
      </div>
      {showDivider && <Divider />}
    </React.Fragment>
  );

  const formItems = [
    portfolioNameInput(),
    portfolioDescription(),
    benchmarkInput(),
    targetAllocationSlider({ equityAllocation, onSliderChange }),
    assetClassSelect(),
    regionSelect(),
    assetTypeSelect(),
    objectiveSelect(),
    strategyTypeSelect()
  ];

  return (
    <Form form={form} layout="vertical" onFinish={onSubmit}>
        <Tabs tabPosition={'top'} centered={true}>
          <Tabs.TabPane key={'1'} tab={'Details'}>
              <Row justify={'center'}>
                  <Card bordered={true} style={{maxWidth: 900}}>
                      {formItems.map((item, index) =>
                        renderFormItem(item, index, index !== formItems.length - 1)
                      )}
                  </Card>
              </Row>
          </Tabs.TabPane>
          <Tabs.TabPane key={'2'} tab={'Present'}>
              <PresentForm selectedTickers={selectedTickers}
                           handleTickerUpdate={handleTickerUpdate}
                           selectedPortfolios={selectedPortfolios}
                           handlePortfolioUpdate={handlePortfolioUpdate}

              />
          </Tabs.TabPane>
        </Tabs>
    </Form>
  );
};

export default PortfolioForm;
